__turbopack_context__.v({
  "backdrop": "MobileNav-module__YT3-GG__backdrop",
  "bar": "MobileNav-module__YT3-GG__bar",
  "barBotOpen": "MobileNav-module__YT3-GG__barBotOpen",
  "barMid": "MobileNav-module__YT3-GG__barMid",
  "barMidOpen": "MobileNav-module__YT3-GG__barMidOpen",
  "barTopOpen": "MobileNav-module__YT3-GG__barTopOpen",
  "close": "MobileNav-module__YT3-GG__close",
  "closeIcon": "MobileNav-module__YT3-GG__closeIcon",
  "cta": "MobileNav-module__YT3-GG__cta",
  "ctaBlock": "MobileNav-module__YT3-GG__ctaBlock",
  "drawer": "MobileNav-module__YT3-GG__drawer",
  "drawerFooter": "MobileNav-module__YT3-GG__drawerFooter",
  "drawerScrollable": "MobileNav-module__YT3-GG__drawerScrollable",
  "linkToggle": "MobileNav-module__YT3-GG__linkToggle",
  "linkToggleOpen": "MobileNav-module__YT3-GG__linkToggleOpen",
  "navLink": "MobileNav-module__YT3-GG__navLink",
  "navList": "MobileNav-module__YT3-GG__navList",
  "subDot": "MobileNav-module__YT3-GG__subDot",
  "subLink": "MobileNav-module__YT3-GG__subLink",
  "subLinkAll": "MobileNav-module__YT3-GG__subLinkAll",
  "subList": "MobileNav-module__YT3-GG__subList",
  "toggle": "MobileNav-module__YT3-GG__toggle",
  "toggleChevron": "MobileNav-module__YT3-GG__toggleChevron",
  "toggleChevronUp": "MobileNav-module__YT3-GG__toggleChevronUp",
});
